import { createFileRoute } from "@tanstack/react-router";
import DondeContratarSeoLocalCerca from "@/pages/DondeContratarSeoLocalCerca";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const canonicalUrl = "https://agenciaseoevolution.com/donde-contratar-seo-local-cerca";

const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "Consultoría SEO Local Presencial",
  provider: {
    "@type": "ProfessionalService",
    name: "SEOEVOLUTION",
    geo: {
      "@type": "GeoCoordinates",
      latitude: "40.4168",
      longitude: "-3.7038",
    },
    areaServed: {
      "@type": "GeoShape",
      circle: "40.4168,-3.7038 50000",
    },
  },
  description: "Servicio de SEO Local con consultoría presencial o remota, optimización GEO y posicionamiento en Google Maps",
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "¿Dónde puedo contratar SEO Local cerca de mí?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "En SEOEVOLUTION ofrecemos consultoría SEO Local presencial y online en toda España. Con nuestro modelo de zonas exclusivas, blindamos por contrato no trabajar con tu competencia directa en tu área geográfica.",
      },
    },
    {
      "@type": "Question",
      name: "¿Necesito contratar una agencia presencial o puede ser remota?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ambas opciones son efectivas. Ofrecemos consultoría presencial en Madrid, Barcelona y principales ciudades, y servicio remoto con resultados idénticos gracias a nuestra plataforma de seguimiento en tiempo real.",
      },
    },
  ],
};

const breadcrumbSchema = buildBreadcrumb([{ name: "Dónde contratar SEO local cerca", path: "/donde-contratar-seo-local-cerca" }]);

export const Route = createFileRoute("/donde-contratar-seo-local-cerca")({
  head: () => ({
    meta: [
      { title: "¿Dónde Contratar SEO Local Cerca de Mi Ubicación?" },
      {
        name: "description",
        content:
          "¿Buscas una agencia SEO Local cerca de ti? Encuentra expertos premium en posicionamiento GEO en tu zona. Consultoría presencial u online. Primeros resultados medibles en 60–90 días.",
      },
      {
        name: "keywords",
        content: "donde contratar seo local, agencia seo cerca de mi, seo local en mi zona, consultoria seo presencial",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: canonicalUrl },
      { property: "og:title", content: "¿Dónde Contratar SEO Local Cerca de Mi Ubicación?" },
      {
        property: "og:description",
        content:
          "¿Buscas una agencia SEO Local cerca de ti? Encuentra expertos premium en posicionamiento GEO en tu zona. Consultoría presencial u online. Primeros resultados medibles en 60–90 días.",
      },
      { name: "twitter:title", content: "¿Dónde Contratar SEO Local Cerca de Mi Ubicación?" },
      {
        name: "twitter:description",
        content:
          "¿Buscas una agencia SEO Local cerca de ti? Encuentra expertos premium en posicionamiento GEO en tu zona. Consultoría presencial u online. Primeros resultados medibles en 60–90 días.",
      },
      { name: "geo.region", content: "ES" },
      { name: "geo.placename", content: "España" },
      { name: "geo.position", content: "40.4168;-3.7038" },
      { name: "ICBM", content: "40.4168, -3.7038" },
    ],
    links: [{ rel: "canonical", href: canonicalUrl }],
    scripts: [
      ldJson(breadcrumbSchema),
      { type: "application/ld+json", children: JSON.stringify(serviceSchema) },
      { type: "application/ld+json", children: JSON.stringify(faqSchema) },
    ],
  }),
  component: DondeContratarSeoLocalCerca,
});
